import { request } from '../../network';
import { handlePhoenixErrors } from '../network/handlePhoenixErrors';
import type { KalturaApiResponse } from '../network/type';

export type FetchConfigurationByDeviceArgs = {
  applicationName: string;
  clientTag: string;
  clientVersion: string;
  endpoint: string;
  platform: string;
  tag: string;
  udid: string;
  partnerId?: number;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/configurations/action/serveByDevice
 */
export async function fetchConfigurationByDevice<T = unknown>({
  applicationName,
  clientTag,
  clientVersion,
  endpoint,
  platform,
  tag,
  udid,
  partnerId,
}: FetchConfigurationByDeviceArgs) {
  const queryParams = {
    clientTag,
  };

  const response = await request<T & KalturaApiResponse<unknown>>({
    url: endpoint + '/api_v3/service/configurations/action/serveByDevice',
    queryParams,
    method: 'post',
    body: {
      apiVersion: '5.4.0',
      applicationName,
      clientTag,
      clientVersion,
      ...(partnerId && { partnerId }),
      language: '*',
      platform,
      tag,
      udid,
    },
  });

  if (response.result && response.result.error?.code) {
    handlePhoenixErrors(response);
  }

  return response;
}
